import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { Variables } from "../../Variations/Variations";
import { toast } from "react-toastify";
import { AiOutlineRight } from "react-icons/ai";

const ManageImageCarousel = () => {
  const { ImageCarouselID } = useParams();
  const navigate = useNavigate();
  const imageCarouselIdNum = Number(ImageCarouselID) || 0;

  // ---- State (matches NEW API JSON) ----
  const [title, setTitle] = useState("");
  const [titleAr, setTitleAr] = useState("");

  const [imageUrl1, setImageUrl1] = useState("");
  const [imageUrl2, setImageUrl2] = useState("");
  const [imageUrl3, setImageUrl3] = useState("");

  const [imageText1, setImageText1] = useState("");
  const [imageText1Ar, setImageText1Ar] = useState("");
  const [imageText2, setImageText2] = useState("");
  const [imageText2Ar, setImageText2Ar] = useState("");
  const [imageText3, setImageText3] = useState("");
  const [imageText3Ar, setImageText3Ar] = useState("");


  const [buttonUrl1, setButtonUrl1] = useState("");    // Text 1 button (Design 2)
  const [buttonUrl2, setButtonUrl2] = useState("");    // Image 2 button (Design 2)
  const [buttonUrl3, setButtonUrl3] = useState("");    // Image 3 button (Design 2)

  const [buttonText1, setButtonText1] = useState("");      // Text 1 EN
  const [buttonText1Ar, setButtonText1Ar] = useState("");  // Text 1 AR
  const [buttonText2, setButtonText2] = useState("");      // Img 2 EN
  const [buttonText2Ar, setButtonText2Ar] = useState("");  // Img 2 AR
  const [buttonText3, setButtonText3] = useState("");      // Img 3 EN
  const [buttonText3Ar, setButtonText3Ar] = useState("");  // Img 3 AR

  const [typeId, setTypeId] = useState(null); // 1 or 2
  const [isPublished, setIsPublished] = useState(false);
  const [widgetId, setWidgetId] = useState(null); // number|null

  // ---- Widgets for select ----
  const [widgets, setWidgets] = useState([]);
  const widgetOptions = (Array.isArray(widgets) ? widgets : [])
    .filter((w) => parseInt(w.WidgetTypeId) === 3) // image carousel widget type
    .map((w) => ({
      value: Number(w.Id),
      label: w.DisplayName ?? w.Name ?? String(w.Id),
    }));
  const selectedWidgetOption =
    widgetOptions.find((o) => o.value === Number(widgetId)) || null;

  // ---- Design select ----
  const typeOptions = [
    { value: 1, label: "Design 1" },
    { value: 2, label: "Design 2" },
  ];
  const selectedTypeOption =
    typeOptions.find((o) => o.value === Number(typeId)) || null;

  // ---- Refs / utils ----
  const fileInput1Ref = useRef(null);
  const fileInput2Ref = useRef(null);
  const fileInput3Ref = useRef(null);
  const isBlank = (v) => typeof v !== "string" || v.trim() === "";

  // ---- Derived flags ----
  const isDesign1 = Number(typeId) === 1; // Beauty
  const isDesign2 = Number(typeId) === 2; // Blogs

  // ---- Clear unused fields on design change ----
  useEffect(() => {
    if (isDesign1) {
      // Use images 1,2,3 + GLOBAL button; clear per-item fields
      setImageText1("");
      setImageText1Ar("");
      setButtonUrl1("");
      setButtonText1("");
      setButtonText1Ar("");

      setImageText2("");
      setImageText2Ar("");
      setButtonUrl2("");
      setButtonText2("");
      setButtonText2Ar("");

      setImageText3("");
      setImageText3Ar("");
      setButtonUrl3("");
      setButtonText3("");
      setButtonText3Ar("");
      // Keep imageUrl1/2/3 and global button
    } else if (isDesign2) {
      // No global button in D2; no Image 1
      setImageUrl1("");
      // Keep Text1 + Img2/Img3 + their captions/buttons
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeId]);

  // ---- Loaders ----
  async function loadWidgets() {
    try {
      const res = await fetch(`${Variables.API_URL}Rasha/Widget/Get`);
      if (!res.ok) throw new Error();
      setWidgets(await res.json());
    } catch {
      toast.error("Failed to load widgets");
    }
  }

  async function loadImageCarousel() {
    try {
      const res = await fetch(
        `${Variables.API_URL}Rasha/ImageCarousel/Get/${imageCarouselIdNum}`
      );
      if (!res.ok) return;
      const data = await res.json();
      const s = data?.ImageCarousel ?? data ?? {};

      setTitle(s.title ?? s.Title ?? "");
      setTitleAr(s.titleAr ?? s.TitleAr ?? "");

      setImageUrl1(s.imageUrl1 ?? s.ImageUrl1 ?? "");
      setImageUrl2(s.imageUrl2 ?? s.ImageUrl2 ?? "");
      setImageUrl3(s.imageUrl3 ?? s.ImageUrl3 ?? "");

      setImageText1(s.imageText1 ?? s.ImageText1 ?? "");
      setImageText1Ar(s.imageText1Ar ?? s.ImageText1Ar ?? "");
      setImageText2(s.imageText2 ?? s.ImageText2 ?? "");
      setImageText2Ar(s.imageText2Ar ?? s.ImageText2Ar ?? "");
      setImageText3(s.imageText3 ?? s.ImageText3 ?? "");
      setImageText3Ar(s.imageText3Ar ?? s.ImageText3Ar ?? "");

      setButtonUrl1(s.buttonUrl1 ?? s.ButtonUrl1 ?? "");
      setButtonUrl2(s.buttonUrl2 ?? s.ButtonUrl2 ?? "");
      setButtonUrl3(s.buttonUrl3 ?? s.ButtonUrl3 ?? "");

      setButtonText1(s.buttonText1 ?? s.ButtonText1 ?? "");
      setButtonText1Ar(s.buttonText1Ar ?? s.ButtonText1Ar ?? "");
      setButtonText2(s.buttonText2 ?? s.ButtonText2 ?? "");
      setButtonText2Ar(s.buttonText2Ar ?? s.ButtonText2Ar ?? "");
      setButtonText3(s.buttonText3 ?? s.ButtonText3 ?? "");
      setButtonText3Ar(s.buttonText3Ar ?? s.ButtonText3Ar ?? "");

      setTypeId(
        s.typeId != null ? Number(s.typeId) : s.TypeId != null ? Number(s.TypeId) : null
      );
      setIsPublished(
        typeof s.isPublished === "boolean" ? s.isPublished : Boolean(s.IsPublished)
      );
      setWidgetId(
        s.widgetId != null ? Number(s.widgetId) : s.WidgetId != null ? Number(s.WidgetId) : null
      );
    } catch {
      toast.error("Failed to load ImageCarousel");
    }
  }

  useEffect(() => {
    loadWidgets();
    if (imageCarouselIdNum !== 0) loadImageCarousel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageCarouselIdNum]);

  // ---- Generic uploader (<= 2MB) ----
  const uploadImage = async (file, setImageState) => {
    if (file.size >= 2_000_000) {
      toast.error("Image is not accepted (max 2MB).");
      return;
    }
    const formdata = new FormData();
    formdata.append("Images", file);
    try {
      const response = await fetch(
        `${Variables.API_URL}UploadMedia/UploadImageToServer`,
        { method: "POST", body: formdata, redirect: "follow" }
      );
      const result = await response.json();
      setImageState(result?.[0] ?? "");
    } catch (e) {
      console.error(e);
      toast.error("Image upload failed");
    }
  };

  const onFileInputChange = (setter) => async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    await uploadImage(file, setter);
    e.target.value = "";
  };

  // ---- Validation (per design) ----
  function isValid() {
    if (isBlank(title)) { toast.error("Title is required"); return false; }
    if (isBlank(titleAr)) { toast.error("Title (Arabic) is required"); return false; }
    if (!widgetId || Number(widgetId) <= 0) { toast.error("Widget is required"); return false; }
    if (!typeId || ![1, 2].includes(Number(typeId))) {
      toast.error("Design is required (choose Design 1 or Design 2)");
      return false;
    }

    if (isDesign1) {
      // D1: three images + global button
      if (isBlank(imageUrl1)) { toast.error("Image 1 is required"); return false; }
      if (isBlank(imageUrl2)) { toast.error("Image 2 is required"); return false; }
      if (isBlank(imageUrl3)) { toast.error("Image 3 is required"); return false; }

  

      return true;
    }

    // D2: Text1 (+button) + Image2 (caption+button) + Image3 (caption+button)
    if (isBlank(imageText1) || isBlank(imageText1Ar)) {
      toast.error("Text 1 (EN & AR) is required");
      return false;
    }
    

    if (isBlank(imageUrl2)) { toast.error("Image 2 is required"); return false; }
    if (isBlank(imageText2) || isBlank(imageText2Ar)) {
      toast.error("Image 2 caption (EN & AR) is required");
      return false;
    }
    if (isBlank(buttonUrl2) || isBlank(buttonText2) || isBlank(buttonText2Ar)) {
      toast.error("Image 2 button URL/Text (EN & AR) is required");
      return false;
    }

    if (isBlank(imageUrl3)) { toast.error("Image 3 is required"); return false; }
    if (isBlank(imageText3) || isBlank(imageText3Ar)) {
      toast.error("Image 3 caption (EN & AR) is required");
      return false;
    }
    if (isBlank(buttonUrl3) || isBlank(buttonText3) || isBlank(buttonText3Ar)) {
      toast.error("Image 3 button URL/Text (EN & AR) is required");
      return false;
    }

    return true;
  }

  // ---- Save (Add / Update) ----
  async function handleSubmit(e) {
    e.preventDefault();
    if (!isValid()) return;

    try {
      const payload = (parseInt(imageCarouselIdNum) === 0)
        ? {
            imageUrl1, imageUrl2, imageUrl3,
            title, titleAr,
            buttonUrl:"", buttonText:"", buttonTextAr:"",    // used only in D1
            typeId: Number(typeId),
            imageText1, imageText1Ar,
            imageText2, imageText2Ar,
            imageText3, imageText3Ar,
            buttonUrl1, buttonUrl2, buttonUrl3,
            buttonText1, buttonText1Ar,
            buttonText2, buttonText2Ar,
            buttonText3, buttonText3Ar,
            isPublished,
            widgetId: Number(widgetId),
          }
        : {
            id: imageCarouselIdNum,
            imageUrl1, imageUrl2, imageUrl3,
            title, titleAr,
            buttonUrl:"", buttonText:"", buttonTextAr:"",    // used only in D1
            typeId: Number(typeId),
            imageText1, imageText1Ar,
            imageText2, imageText2Ar,
            imageText3, imageText3Ar,
            buttonUrl1, buttonUrl2, buttonUrl3,
            buttonText1, buttonText1Ar,
            buttonText2, buttonText2Ar,
            buttonText3, buttonText3Ar,
            isPublished,
            widgetId: Number(widgetId),
          };

      const res = await fetch(`${Variables.API_URL}Rasha/ImageCarousel/Upsert`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error(await res.text());

      toast.success(
        imageCarouselIdNum === 0
          ? "Image Carousel added successfully"
          : "Image Carousel updated successfully"
      );
      navigate("/admin/rasha/ImageCarousel");
    } catch (err) {
      toast.error(err.message || "Failed to save");
    }
  }

  // ---- Render ----
  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        {/* Header */}
        <div className="row mb-3">
          <div className="col-12">
            <h2>
              {imageCarouselIdNum === 0 ? "Add" : `Manage ${title || "Image Carousel"}`} Image Carousel
            </h2>
            <ul className="portalPath">
              <li>Home <AiOutlineRight /></li>
              <li>
                <Link to="/admin/rasha/ImageCarousel">
                  ImageCarousel <AiOutlineRight />
                </Link>
              </li>
              <li>{imageCarouselIdNum === 0 ? "Add" : "Manage"} ImageCarousel</li>
            </ul>
          </div>
        </div>

        {/* Form */}
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-end mb-3">
                  <NavLink to="/admin/rasha/ImageCarousel" className="btn btn-secondary me-2">
                    Cancel
                  </NavLink>
                  <button className="btn btn-primary" onClick={handleSubmit}>
                    Save
                  </button>
                </div>

                <div className="row gy-3">
                  {/* Title */}
                  <div className="col-lg-6">
                    <label className="mb-2">
                      Title <span className="required">*</span>
                    </label>
                    <input
                      id="title"
                      className="form-control"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="Section title"
                    />
                  </div>
                  <div className="col-lg-6">
                    <label className="mb-2">
                      Title (Arabic) <span className="required">*</span>
                    </label>
                    <input
                      id="titleAr"
                      className="form-control"
                      value={titleAr}
                      onChange={(e) => setTitleAr(e.target.value)}
                      placeholder="العنوان"
                    />
                  </div>

                  {/* Publish toggle */}
                  <div className="form-group col-lg-3 d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="publish"
                      checked={isPublished}
                      onChange={(e) => setIsPublished(e.target.checked)}
                    />
                    &nbsp;<label className="form-check-label" htmlFor="publish">Publish</label>
                  </div>

                  {/* Widget select */}
                  <div className="col-lg-6">
                    <label className="mb-2">
                      Widget <span className="required">*</span>
                    </label>
                    <Select
                      options={widgetOptions}
                      value={selectedWidgetOption}
                      onChange={(opt) => setWidgetId(opt ? opt.value : null)}
                      placeholder="Select a widget…"
                      isClearable
                    />
                  </div>

                  {/* Design select */}
                  <div className="col-lg-6">
                    <label className="mb-2">
                      Design <span className="required">*</span>
                    </label>
                    <Select
                      options={typeOptions}
                      value={selectedTypeOption}
                      onChange={(opt) => setTypeId(opt ? opt.value : null)}
                      placeholder="Choose design…"
                      isClearable
                    />
                  </div>

                 

                  {/* ----- Blocks start ----- */}
                  <div className="col-12"><hr /></div>

                  {isDesign1 && (
                    <>
                      {/* ======= Design 1: Image 1 / 2 / 3 ======= */}
                      {/* Image 1 */}
                      <div className="col-12"><h5>Image 1</h5></div>
                      <div className="col-lg-6">
                        <label className="mb-2">Image 1 (max 2MB)</label>
                        <input
                          ref={fileInput1Ref}
                          type="file"
                          accept="image/*"
                          className="form-control"
                          onChange={onFileInputChange(setImageUrl1)}
                        />
                        {imageUrl1 && (
                          <div className="mt-2">
                            <img src={Variables.API_PUBLISHED + imageUrl1} alt="img1"
                                 style={{ maxWidth: "100%", maxHeight: 200, display: "block" }} />
                            <button type="button" className="btn btn-sm btn-outline-danger mt-2"
                                    onClick={() => setImageUrl1("")}>
                              Remove Image 1
                            </button>
                            <small className="text-muted d-block mt-2">URL: {imageUrl1}</small>
                          </div>
                        )}
                      </div>

                      {/* Image 2 */}
                      <div className="col-12"><hr /></div>
                      <div className="col-12"><h5>Image 2</h5></div>
                      <div className="col-lg-6">
                        <label className="mb-2">Image 2 (max 2MB)</label>
                        <input
                          ref={fileInput2Ref}
                          type="file"
                          accept="image/*"
                          className="form-control"
                          onChange={onFileInputChange(setImageUrl2)}
                        />
                        {imageUrl2 && (
                          <div className="mt-2">
                            <img src={Variables.API_PUBLISHED + imageUrl2} alt="img2"
                                 style={{ maxWidth: "100%", maxHeight: 200, display: "block" }} />
                            <button type="button" className="btn btn-sm btn-outline-danger mt-2"
                                    onClick={() => setImageUrl2("")}>
                              Remove Image 2
                            </button>
                            <small className="text-muted d-block mt-2">URL: {imageUrl2}</small>
                          </div>
                        )}
                      </div>

                      {/* Image 3 */}
                      <div className="col-12"><hr /></div>
                      <div className="col-12"><h5>Image 3</h5></div>
                      <div className="col-lg-6">
                        <label className="mb-2">Image 3 (max 2MB)</label>
                        <input
                          ref={fileInput3Ref}
                          type="file"
                          accept="image/*"
                          className="form-control"
                          onChange={onFileInputChange(setImageUrl3)}
                        />
                        {imageUrl3 && (
                          <div className="mt-2">
                            <img src={Variables.API_PUBLISHED + imageUrl3} alt="img3"
                                 style={{ maxWidth: "100%", maxHeight: 200, display: "block" }} />
                            <button type="button" className="btn btn-sm btn-outline-danger mt-2"
                                    onClick={() => setImageUrl3("")}>
                              Remove Image 3
                            </button>
                            <small className="text-muted d-block mt-2">URL: {imageUrl3}</small>
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {isDesign2 && (
                    <>
                      {/* ======= Design 2: Text 1 + Image 2 + Image 3 (with captions/buttons) ======= */}
                      {/* Text 1 */}
                      <div className="col-12"><h5>Text 1</h5></div>
                      <div className="col-lg-6">
                        <label className="mb-2">Text 1 (EN) <span className="required">*</span></label>
                        <input
                          className="form-control mb-3"
                          value={imageText1}
                          onChange={(e) => setImageText1(e.target.value)}
                          placeholder="e.g., Rasha’s Daily Mama Life Blogs"
                        />
                        <label className="mb-2">Text 1 (AR) <span className="required">*</span></label>
                        <input
                          className="form-control mb-3"
                          value={imageText1Ar}
                          onChange={(e) => setImageText1Ar(e.target.value)}
                          placeholder="عنوان النص ١"
                        />
                      </div>
                    

                      {/* Image 2 + caption/button */}
                      <div className="col-12"><hr /></div>
                      <div className="col-12"><h5>Image 2</h5></div>
                      <div className="col-lg-6">
                        <label className="mb-2">Image 2 (max 2MB) <span className="required">*</span></label>
                        <input
                          ref={fileInput2Ref}
                          type="file"
                          accept="image/*"
                          className="form-control"
                          onChange={onFileInputChange(setImageUrl2)}
                        />
                        {imageUrl2 && (
                          <div className="mt-2">
                            <img src={Variables.API_PUBLISHED + imageUrl2} alt="img2"
                                 style={{ maxWidth: "100%", maxHeight: 200, display: "block" }} />
                            <button type="button" className="btn btn-sm btn-outline-danger mt-2"
                                    onClick={() => setImageUrl2("")}>
                              Remove Image 2
                            </button>
                            <small className="text-muted d-block mt-2">URL: {imageUrl2}</small>
                          </div>
                        )}
                      </div>
                      <div className="col-lg-6">
                        <label className="mb-2">Image 2 Caption (EN) <span className="required">*</span></label>
                        <input
                          className="form-control mb-3"
                          value={imageText2}
                          onChange={(e) => setImageText2(e.target.value)}
                          placeholder="Being a Mom of three"
                        />
                        <label className="mb-2">Image 2 Caption (AR) <span className="required">*</span></label>
                        <input
                          className="form-control mb-3"
                          value={imageText2Ar}
                          onChange={(e) => setImageText2Ar(e.target.value)}
                          placeholder="أم لثلاثة أطفال"
                        />
                        <label className="mb-2">Image 2 Button URL <span className="required">*</span></label>
                        <input
                          className="form-control mb-3"
                          value={buttonUrl2}
                          onChange={(e) => setButtonUrl2(e.target.value)}
                          placeholder="https://..."
                        />
                        <div className="row">
                          <div className="col-6">
                            <label className="mb-2">Image 2 Button Text <span className="required">*</span></label>
                            <input
                              className="form-control"
                              value={buttonText2}
                              onChange={(e) => setButtonText2(e.target.value)}
                              placeholder="Read Blog"
                            />
                          </div>
                          <div className="col-6">
                            <label className="mb-2">Image 2 Button Text (AR) <span className="required">*</span></label>
                            <input
                              className="form-control"
                              value={buttonText2Ar}
                              onChange={(e) => setButtonText2Ar(e.target.value)}
                              placeholder="اقرأ المدونة"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Image 3 + caption/button */}
                      <div className="col-12"><hr /></div>
                      <div className="col-12"><h5>Image 3</h5></div>
                      <div className="col-lg-6">
                        <label className="mb-2">Image 3 (max 2MB) <span className="required">*</span></label>
                        <input
                          ref={fileInput3Ref}
                          type="file"
                          accept="image/*"
                          className="form-control"
                          onChange={onFileInputChange(setImageUrl3)}
                        />
                        {imageUrl3 && (
                          <div className="mt-2">
                            <img src={Variables.API_PUBLISHED + imageUrl3} alt="img3"
                                 style={{ maxWidth: "100%", maxHeight: 200, display: "block" }} />
                            <button type="button" className="btn btn-sm btn-outline-danger mt-2"
                                    onClick={() => setImageUrl3("")}>
                              Remove Image 3
                            </button>
                            <small className="text-muted d-block mt-2">URL: {imageUrl3}</small>
                          </div>
                        )}
                      </div>
                      <div className="col-lg-6">
                        <label className="mb-2">Image 3 Caption (EN) <span className="required">*</span></label>
                        <input
                          className="form-control mb-3"
                          value={imageText3}
                          onChange={(e) => setImageText3(e.target.value)}
                          placeholder="Patience is Parenting main Advice"
                        />
                        <label className="mb-2">Image 3 Caption (AR) <span className="required">*</span></label>
                        <input
                          className="form-control mb-3"
                          value={imageText3Ar}
                          onChange={(e) => setImageText3Ar(e.target.value)}
                          placeholder="الصبر هو نصيحة التربية الأساسية"
                        />
                        <label className="mb-2">Image 3 Button URL <span className="required">*</span></label>
                        <input
                          className="form-control mb-3"
                          value={buttonUrl3}
                          onChange={(e) => setButtonUrl3(e.target.value)}
                          placeholder="https://..."
                        />
                        <div className="row">
                          <div className="col-6">
                            <label className="mb-2">Image 3 Button Text <span className="required">*</span></label>
                            <input
                              className="form-control"
                              value={buttonText3}
                              onChange={(e) => setButtonText3(e.target.value)}
                              placeholder="Read Blog"
                            />
                          </div>
                          <div className="col-6">
                            <label className="mb-2">Image 3 Button Text (AR) <span className="required">*</span></label>
                            <input
                              className="form-control"
                              value={buttonText3Ar}
                              onChange={(e) => setButtonText3Ar(e.target.value)}
                              placeholder="اقرأ المدونة"
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {/* ----- Blocks end ----- */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
};

export default ManageImageCarousel;
